import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Ordering flows merge ad-hoc keys into this state (keyEntry, studentId,
// subjectName, studentPreviewImageUrl, …), so the shape stays open beyond
// the declared defaults.
export interface AdditionalDataState {
  enableZoomOnProducts: boolean;
  enableZoomOnSubjects: boolean;
  eventCategory: string | null;
  keySubmittedByUser: string | null;
  picsGalleryId: number | null;
  picsGalleryPassword: string | null;
  primaryPreviewImageUrl: string | null;
  eventType: string | null;
  [key: string]: unknown;
}

const initialState: AdditionalDataState = {
  enableZoomOnProducts: true,
  enableZoomOnSubjects: true,
  eventCategory: null,
  keySubmittedByUser: null,
  picsGalleryId: null,
  picsGalleryPassword: null,
  primaryPreviewImageUrl: null,
  eventType: null,
};

const additionalDataSlice = createSlice({
  name: 'additionalData',
  initialState,
  reducers: {
    setAdditionalData(
      state,
      action: PayloadAction<Partial<AdditionalDataState>>,
    ) {
      Object.assign(state, action.payload);
    },
    resetAdditionalData() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase<
      'V3_RESTORE_ABANDONED_CART_ATTRIBUTION',
      PayloadAction<
        { orders?: object; uuid?: string },
        'V3_RESTORE_ABANDONED_CART_ATTRIBUTION'
      >
    >('V3_RESTORE_ABANDONED_CART_ATTRIBUTION', (_state, action) => {
      if (action.payload.orders && action.payload.uuid) return initialState;
    });
  },
});

export const { setAdditionalData, resetAdditionalData } =
  additionalDataSlice.actions;

export default additionalDataSlice.reducer;
